import type { GetPageContentResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

export interface GitBookContentParams {
  pageId?: string;
  pagePath?: string;
}

export const getGitBookContent = async ({
  pageId,
  pagePath,
}: GitBookContentParams): Promise<GetPageContentResponseBodyType> => {
  const response = await api.get<GetPageContentResponseBodyType>(
    "/v2/gitbook/content",
    {
      params: pageId ? { pageId } : { pagePath },
    }
  );

  return response.data;
};

export const useGetGitBookContent = (params: GitBookContentParams | null) => {
  const pageId = params?.pageId;
  const pagePath = params?.pagePath;

  return useQuery({
    queryKey: ["gitbook", pageId ? "page" : "content", pageId ?? pagePath],
    queryFn: async () => getGitBookContent({ pageId, pagePath }),
    retry: false,
    enabled: Boolean(pageId || pagePath),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    meta: { onError: { any: "ignore" } },
  });
};
